import { Fragment, useCallback } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { __CERTIFICATION_API_URL__ } from 'shell/constants/environment';
import FormCertificate, { CertificateForm } from 'front-office/components/released-services/form';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { ReleasedService } from 'shell/models/certificate';
import { HttpResponse } from 'shell/models/http-response';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { CommonCertificateCrumbs } from '../constants';
import { toast } from 'react-toastify';
import { transformCertificate } from 'front-office/components/released-services/utils/transform-certificate';
import { useHttpClient } from 'shell/hooks/use-http-fetch/stateless';
import { ResponsePromise } from 'shell/hooks/use-http-fetch/stateless/type';
import { updateRequestTransformer } from 'front-office/utils/released-service-request-transformer';

const ReleasedServiceEditPage = (): React.ReactElement => {
  const params = useParams();

  const [certificate] = useHttpFetch<HttpResponse<ReleasedService>, CertificateForm>(
    `${__CERTIFICATION_API_URL__}/certificazione/registro-doc-rilasciati/${params.idSigla}/${params.idAnno}/${params.progressivo}`,
    {
      onBootstrap: true,
      options: {
        errorCatching: true,
        method: 'GET',
        loading: true,
        data: {},
      },
      transformer: transformCertificate,
    }
  );

  const updateCertificate = useHttpClient(
    `${__CERTIFICATION_API_URL__}/certificazione/registro-doc-rilasciati/${params.idSigla}-${params.idAnno}-${params.progressivo}`,
    {
      options: {
        errorCatching: true,
        method: 'PUT',
        loading: true,
        data: {},
      },
    }
  );

  const navigate = useNavigate();

  const onSubmit = useCallback(
    (formValues: CertificateForm | undefined) => {
      const data = updateRequestTransformer(formValues);

      (
        updateCertificate({
          data,
        }) as ResponsePromise<void, void>
      ).then(() => {
        toast.success('Operazione eseguita con successo');
        navigate('/sportello/controllo-di-cassa');
      });
    },
    [updateCertificate, navigate]
  );

  return (
    <Fragment>
      <Breadcrumbs items={[...CommonCertificateCrumbs, { name: 'Modifica Certificato' }]} />
      {certificate.isLoading || !certificate.data ? null : (
        <FormCertificate
          title="Modifica Servizio rilasciato"
          onOk={onSubmit}
          onGoBack={() => {
            navigate('/sportello/controllo-di-cassa');
          }}
          isEdit
          disabled
          initialValues={certificate.data as CertificateForm}
        />
      )}
    </Fragment>
  );
};

ReleasedServiceEditPage.displayName = 'Cash Check Edit page component';

export default ReleasedServiceEditPage;
